import {
  Button, Flex, Table, Text
} from 'onefaceui-react-components';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Tab, TabList, TabPanel,
  Tabs
} from 'react-tabs';
import * as stockSummaryModalActions from 'react/api/actions/stockSummaryModal';
import StockSummaryModal from 'react/containers/modals/StockSummaryModal';
import { getResourceTo } from 'react/utils/utils';
import { DefaultRequest } from 'scripts/api';
import { Container, LastSync, SeeDetailsContent } from './styles';

export default function StockTable({ routeId }) {
  const [isDisableButton, setIsDisableButton] = useState(true);
  const [lastSyncText, setLastSyncText] = useState(null);
  const tableRef = useRef(null);
  const dispatch = useDispatch();

  const columns = [
    {
      title: 'Key',
      field: 'key',
      width: 100,
      frozen: true,
      headerSort: false
    },
    {
      title: 'Description',
      field: 'description',
      width: 200,
      frozen: true,
      headerSort: false
    },
    {
      title: 'Actual',
      field: 'stock.$display',
      width: 100,
      frozen: true,
      headerSort: false
    }
  ];

  const getAndListOrganizations = (routeIdParam) => {
    tableRef.current.setLoading(true);
    new DefaultRequest({
      method: 'GET',
      url: `Stock/${routeIdParam}`,
      success: (response) => {
        App.Forms.RouteSummaryStock.staticData = response;

        tableRef.current.setData(response);
        tableRef.current.setLoading(false);

        setIsDisableButton(!response.length);
      },
      error: () => {
        tableRef.current.setLoading(false);
      }
    }).send();
  };

  const getStockSummaryContainer = () => {
    let container = document.getElementById('routeStockSummary');

    if (!container) {
      container = document.createElement('div');
      container.id = 'routeStockSummary';
      document.getElementById('RouteSummary').appendChild(container);
    }

    return container;
  };

  const openStockSummaryModal = () => {
    dispatch(stockSummaryModalActions.actionCreators.open());
  };

  const getLastSync = () => {
    const url = 'Stop/restrictions?criteria={"filters":["id","route.id","location.description","key","actualDeparture", "actualArrival"],"firstResult":0,"maxResults":1}';

    const request = new DefaultRequest({
      url,
      method: 'post',
      data: {
        criteriaChain: [
          {
            and: [
              {
                attr: 'route.id',
                eq: routeId
              },
              {
                attr: 'actualSequenceNum',
                isNull: false
              }
            ]
          }
        ],
        sort: [
          {
            attr: 'actualSequenceNum',
            type: 'DESC'
          }
        ]
      },
      success(response) {
        if (response.length) {
          const stop = response[0];

          const arrivalDate = Monet.Format.DateTime.formatToLocale(stop.actualArrival);
          const locationDescription = stop.location?.description || '';

          const lastSyncResource = Monet.I18n.getResourcesByKey('Greenmile.RouteMonitor.sidebar.lastSync');
          const lastSync = lastSyncResource
            .replace('@hour@', arrivalDate || '')
            .replace('@stopKey@', `${stop.id || ''}`)
            .replace('@stopDescription@', locationDescription);

          setLastSyncText(lastSync);
        } else {
          setLastSyncText(null);
        }
      }
    });

    request.send();
  };

  useEffect(() => {
    const allModals = document.querySelectorAll('#routeStockSummary .generic-modal-portal');

    allModals.forEach((item, i) => {
      if (allModals.length - 1 !== i) {
        item.remove();
      }
    });
  }, []);

  useEffect(() => {
    App.Forms.RouteSummaryStock = {};

    getAndListOrganizations(routeId);
    getLastSync();
  }, [routeId]);

  return (
    <Container>
      <SeeDetailsContent>
        <Text>{getResourceTo('Greenmile.RouteMonitor.sidebar.route.StockSummary')}</Text>
        <Button disabled={isDisableButton} onClick={openStockSummaryModal}>{getResourceTo('Greenmile.RouteMonitor.sidebar.route.StockDetails')}</Button>
      </SeeDetailsContent>
      <Tabs>
        <TabList>
          <Tab>
            <Text size="xs" type="secondary" className="tab-text">
              {getResourceTo('Greenmile.RouteMonitor.sidebar.routeMaterialTab')}
            </Text>
          </Tab>
        </TabList>
        <TabPanel>
          <Flex className="stock-table-wrapper">
            <Table
              ref={tableRef}
              tableOptions={{
                layout: 'fitDataStretch',
                rowHeight: 28
              }}
              columns={columns}
              noDataMessage={getResourceTo('general.noDataFound')}
              events={{
                rowMouseEnter: (e, tableArgs) => {
                  const dataRow = tableArgs.getData();
                  Greenmile.RouteSummary.SideBar.stockSummaryShowInfo(e, dataRow);
                },
                rowMouseLeave: () => {
                  Greenmile.RouteSummary.SideBar.stockSummaryMouseOutSlice();
                }
              }}
            />
          </Flex>
          <LastSync alignItems="center">
            <Text size="xs" className="tab-text">
              {lastSyncText}
            </Text>
          </LastSync>
        </TabPanel>
      </Tabs>
      <StockSummaryModal
        parentSelector={getStockSummaryContainer}
        routeId={Number(routeId)}
        title={Monet.I18n.getResourcesByKey('Greenmile.RouteMonitor.StockSummary.Modal.Title')}
        subtitle={Monet.I18n.getResourcesByKey('Greenmile.RouteMonitor.StockSummary.Modal.Subtitle')}
        lastSyncText={lastSyncText}
      />
    </Container>
  );
}

StockTable.propTypes = {
  routeId: PropTypes.number.isRequired
};
